import { useState, useEffect } from 'react';
import ufo from "../../../assets/CalibrationGame/ufo.png";
import energyRing from "../../../assets/CalibrationGame/ring.svg";
import './UFOFlyEffect.css';



const UFOMotion = ({ start, end, setStartAnimation, setClickCount, shouldStart, onStop, turns }) => {

    const [position, setPosition] = useState(start);
    const [stepCount, setStepCount] = useState(0);
    const [movingToEnd, setMovingToEnd] = useState(false);

    useEffect(() => {
        if (!shouldStart) return;
        const moveRandomly = () => {
            const randomX = Math.random() * window.innerWidth;
            const randomY = Math.random() * window.innerHeight;
            setPosition({ x: randomX, y: randomY });
        };
        const moveToEndpoint = () => {
            setPosition(end);
        };
        const interval = setInterval(() => {
            if (stepCount < turns && !movingToEnd) {
                moveRandomly();
                setStepCount((prevStepCount) => prevStepCount + 1);
            } else {
                setMovingToEnd(true);
                moveToEndpoint();
                clearInterval(interval);
                setStepCount(0);
                setTimeout(() => {  
                    if(!!setStartAnimation) setStartAnimation(false)
                    if(!!onStop) onStop()
                    if(!!setClickCount) setClickCount(0)
                    setMovingToEnd(false);
                }, 2600);
            }
        }, 500);
        return () => clearInterval(interval);
    }, [shouldStart, stepCount, movingToEnd, end, onStop]);

    const pointStyle = {
        width: "30px",
        height: "30px",
        position: "absolute",
        transition: "transform 3s ease",
        transform: `translate(${position.x}px, ${position.y}px)`
    };

    const UFOStyle = {
        width: "80px", 
        position: "absolute",
        left:-25,
        top:-20,
    }

    const energyRingStyle = {
            width:"65px",
            position:"absolute",
            left:-16,
            top:-14
    }

    return (

        <>
            <div style={pointStyle}>
                {!shouldStart &&
                    <img src={energyRing} style={energyRingStyle} />
                }
                <img
                    src={ufo}
                    style={UFOStyle}
                />
            </div>
        </>

    );
}


export default UFOMotion;




